import React, { useCallback, useRef, useState } from "react";
import ListPageHeader from "../../utilities/ListPageHeader";
import AgGridTable from "../../utilities/AgGridTable";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { Button, IconButton, Typography } from "@mui/material";
import Cards from "./Card";
import RequestCalender from "./RequestCalender";
import { useNavigate } from "react-router-dom";
import FusePageCarded from "@fuse/core/FusePageCarded/FusePageCarded";
import ChartDesigner from "./ChartDesigner";
import ChartRequestType from "./ChartRequestType";
import ChartRequestStatus from "./ChartRequestStatus";
import data from "../request/data";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";

const url = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.dailyExchangeRate}`;

const EditRenderer = (props) => {
  return (
    <span>
      <IconButton>
        <FuseSvgIcon size={15} color="action">
          heroicons-outline:document-search
        </FuseSvgIcon>
      </IconButton>
    </span>
  );
};

export default function Dashboard() {
  const navigate = useNavigate();
  const [error, setError] = useState();
  const [rowData, setRowData] = useState(data);
  const gridRef = useRef();
  const [showPaginationDropdown, setShowPaginationDropdown] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: "Sno.",
      valueGetter: "node.rowIndex + 1",
      maxWidth: 100,
    },
    { field: "requestId", headerName: "Request .No", enableRowGroup: true },
    { field: "partners", headerName: "Partners", enableRowGroup: true },
    { field: "showroom", headerName: "Showroom", enableRowGroup: true },
    { field: "type", headerName: "Type", enableRowGroup: true },
    { field: "createDate", enableRowGroup: true, headerName: "Create Date" },
    { field: "assignee", enableRowGroup: true, headerName: "Assignee" },
    { field: "status", enableRowGroup: true, headerName: "Status" },
    {
      headerName: "Action",
      cellRenderer: (data) => <EditRenderer />,
    },
  ]);

  const loadRates = async () => {
    try {
      const list = await OAuthService.getList(url + "?size=1000");
      let rates = list.data?._embedded?.dailyExchangeRates;
      setRowData(rates);
    } catch (error) {
      setError(error.message);
      console.log(error);
    }
  };

  const onGridReady = useCallback((params) => {
    //loadRates();
  }, []);

  const handleViewAll = () => {
    navigate("/design-studio/request-list");
  };

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };

  const onRowDoubleClicked = (params) => {
    var filename = selectedRows[0]?.id;
    navigate("/design-studio/showroom-questionnaire");
  };

  return (
    <>
      <FusePageCarded
        classes={{
          content: "flex",
          header: "min-h-72 h-72 sm:h-136 sm:min-h-136",
        }}
        header={
          <ListPageHeader
            componentName="Dashboard"
            pageName="Dashboard"
            showPaginationDropdown={showPaginationDropdown}
          />
        }
        content={
          <>
            <Cards />
            <div className="px-24 md:px-32">
              <div className="flex flex-col sm:flex-row space-y-16 sm:space-y-0 flex-1 w-full items-center justify-between pb-16">
                <Typography variant="h6">Request List</Typography>
                <div className="flex flex-col w-full sm:w-auto sm:flex-row items-center justify-end space-x-8">
                  <Button
                    type="button"
                    variant="contained"
                    color="warning"
                    className="mx-auto"
                    onClick={handleViewAll}
                  >
                    View All
                  </Button>
                </div>
              </div>
              <div style={{ height: 400 }}>
                <AgGridTable
                  rowData={rowData}
                  columnDefs={columnDefs}
                  onGridReady={onGridReady}
                  gridRef={gridRef}
                  onRowDoubleClicked={onRowDoubleClicked}
                  onSelectionChanged={onSelectionChanged}
                  hideCheckbox={true}
                  editable={false}
                  pagination={false}
                />
              </div>
              <div className="flex flex-col sm:flex sm:flex-row mb-8">
                <div className="w-full sm:w-1/1.5">
                  <RequestCalender />
                </div>
                <div className="w-full sm:w-1/3">
                  <ChartDesigner />
                </div>
              </div>
              <div className="flex flex-col sm:flex sm:flex-row mb-8">
                <div className="w-full sm:w-1/1.5">
                  <ChartRequestType />
                </div>
                <div className="w-full sm:w-1/3">
                  <ChartRequestStatus />
                </div>
              </div>
            </div>
          </>
        }
        innerScroll
      />
    </>
  );
}
